import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, Input } from 'antd';
import moment from 'moment';
import { dataDefault, columnsData } from './data';
import FileSaver from "file-saver";
import Auth from "../Auth";
import TableText from "../TableText";
import { numConvert, calculation, sum } from '@/method'
import _ from 'lodash';

const { TextArea } = Input;
const totalIndex = [6, 13, 20];
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            note: {
                note: ""
            }
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {
        const sumName = [
            'room',
            'breakfast',
            'westernRestaurant',
            'chineseRestaurant',
            'wedd',
            'otherParty',
            'foodServiceIncome',
            'canSell',
            'takeUpRoom',
            'human',
            'hisHelper',
        ];

        totalIndex.forEach(index => {
            sumName.forEach(name => {
                data[index][name] = data.reduce((a, b, i) => {
                    if (i < index && i >= (index - 6)) a += numConvert(b[name]);
                    return a
                }, 0).toFixed(2);
            });
        });

        // 计算occ adr
        data.forEach((item, index) => {
            data[index].occ = calculation(item.takeUpRoom, item.canSell, 3);
            data[index].adr = calculation(item.room, item.takeUpRoom, 0);
            data[index].peopleWork = calculation(
                sum([item.room, item.foodServiceIncome])
                ,
                sum([item.human, item.hisHelper])
                , 2);
        });

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }

    getData = (date) => {
        let data = _.cloneDeep(dataDefault(date));

        fetch(`/mayDayInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data;
            }

            this.setState({ loading: false, note: x.data.note || { note: "" } });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let data = this.state.data.map(x => ({ ...x, year }));
        let note = {
            ...this.state.note,
            year
        };

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('note', JSON.stringify(note));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/mayDaySave', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            const name = `2021年五一假期业绩情况 ${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });

    }

    render() {
        const { data, date, print } = this.state;

        const columns = columnsData(print).map(item => {
            return {
                title: item.title,
                dataIndex: item.key,
                key: item.key,
                width: item.width || 80,
                align: "center",
                fixed: item.fixed || false,
                render: (text, record, index) => {

                    const props = {
                        text,
                        index,
                        type: item.type,
                        name: item.key,
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title: [item.title, record.title],
                            record,
                            sqlName: "_mayday"
                        }
                    };

                    if (item.key == 'human111' && index == 0) {
                        return {
                            children: <TableText data={{ ...props }} />,
                            props: {
                                rowSpan: 21
                            }
                        }
                    } else if (item.key == 'human111') return { props: { rowSpan: 0 } }

                    if (props.type.includes('input') && totalIndex.includes(index)) {
                        props.type = props.type.includes('percent') ? 'percent' : 'number';
                    }

                    if (item.key == 'title' && index % 7 == 0) {
                        return {
                            children: <TableText data={{ ...props }} />,
                            props: {
                                rowSpan: 7
                            }
                        }
                    } else if (item.key == 'title') {
                        return {
                            props: {
                                rowSpan: 0
                            }
                        }
                    }


                    return (
                        <TableText data={{ ...props }} />
                    )
                }
            }
        });

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 tableHeight" >
                    <Row className="title" id="table9_1">
                        <Row>{moment(date).format('YYYY')}年五一假期业绩情况</Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                            scroll={this.state.print ? {} : { y: 500 }}
                        />
                        {/* <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>2021年"五一"假期帮工使用情况 (人力填写)</Row>
                            {!this.state.loading || this.state.print ? <TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row> */}
                    </Row>

                    <Auth loading={this.state.loading} auth="edit_mayday">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >导出Excel</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/mayDay/index.js